import { Input } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'

export const NewDelegateForm = ({ formik }) => {
  return (
    <>
      <Grid item xs={12}>
        <Input
          type="text"
          variant="outlined"
          name="firstName"
          label="First Name"
          width="100%"
          value={formik.values.firstName}
          required
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.firstName && Boolean(formik.errors.firstName)}
          helperText={formik.touched.firstName && formik.errors.firstName}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          type="text"
          variant="outlined"
          name="lastName"
          label="Last Name"
          width="100%"
          value={formik.values.lastName}
          required
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.lastName && Boolean(formik.errors.lastName)}
          helperText={formik.touched.lastName && formik.errors.lastName}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          type="text"
          variant="outlined"
          name="email"
          label="Email"
          width="100%"
          value={formik.values.email}
          required
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          type="text"
          variant="outlined"
          name="phone"
          label="Phone"
          width="100%"
          value={formik.values.phone}
          required
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.phone && Boolean(formik.errors.phone)}
          helperText={formik.touched.phone && formik.errors.phone}
        />
      </Grid>
    </>
  )
}
